import styled from '@emotion/styled';
import { DSButton, DSInput } from '@hundred5/design-system';
import React from 'react';

import { copyText } from '../../common';
import { useNotifications } from '../../notifications';

import { useWorkspaceId } from '@/hooks/router';
import { useGetCareersPage } from '@/queries/careers/queries';
import AdminOnlyIllustration from './assets/careers-page-illustration.png';
import { getHostnameFromApiUrl } from './careers-job-opening-list/careers-job-opening-list.utils';

// TODO: remove exclude from .unimportedrc.json
export function CareersAdminOnly() {
  const workspaceId = useWorkspaceId();
  const query = useGetCareersPage(Number(workspaceId));
  const isPublished = query.data?.published ?? false;
  const apiUrl = import.meta.env.VITE_API_URL;
  const url = query.data?.subdomain
    ? `${query.data?.subdomain}.${getHostnameFromApiUrl(apiUrl)}`
    : '';
  const { addNotification } = useNotifications();
  const copyLink = () => {
    copyText(url);
    addNotification({ type: 'copied_to_clipboard' });
  };

  return (
    <Container>
      <Wrapper>
        <img
          src={AdminOnlyIllustration}
          alt="Admins only illustration"
          height={254}
          width={582}
        />
        <Title>Admins only</Title>
        <Description>Only admins can edit the careers page</Description>
        {isPublished && (
          <CopyLinkWrapper>
            <DSInput value={url} readOnly />
            <DSButton disabled={!url} onClick={copyLink}>
              Copy link
            </DSButton>
          </CopyLinkWrapper>
        )}
      </Wrapper>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 52px;
  background-color: ${(props) => props.theme.colors.white};
  z-index: 3;
  // z-index is needed to show header shadow with background set here
`;

const Wrapper = styled.div`
  width: 582px;
  text-align: center;
  z-index: 5;
`;

const CopyLinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Title = styled.h2`
  font-family: GT Haptik;
  font-weight: 700;
  font-size: 24px;
  color: ${(props) => props.theme.colors.purple[100]};
  margin-top: 24px;
  margin-bottom: 4px;
`;

const Description = styled.p`
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors.purple[60]};
`;
